import {
	Bar,
	BarChart,
	CartesianGrid,
	Legend,
	ReferenceLine,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import type { AttendanceResponse } from "@/adapters/api";
import { formatCount, formatDayLabel } from "../../utils/format.ts";
import { Chart } from "../chart/index.tsx";

export interface AttendancePanelProps {
	data?: AttendanceResponse;
	isPending: boolean;
	isError: boolean;
}

export function AttendancePanel({
	data,
	isPending,
	isError,
}: AttendancePanelProps) {
	const days = (data?.days ?? []).map((day) => ({
		...day,
		label: formatDayLabel(day.date),
	}));
	const hasData = days.some((day) => day.total > 0);
	const headcount = data?.headcount ?? 0;

	return (
		<Chart
			label="Pessoas que bateram ponto no canteiro por dia"
			height={240}
			isPending={isPending}
			isError={isError}
			isEmpty={!hasData}
			emptyMessage="Nenhum ponto registrado no período."
			table={{
				columns: ["Dia", "Pessoas"],
				rows: days.map((day) => [day.label, formatCount(day.total)]),
			}}
		>
			<BarChart data={days} margin={{ top: 8, right: 8, bottom: 0, left: 0 }}>
				<CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
				<XAxis dataKey="label" tickLine={false} axisLine={false} />
				<YAxis allowDecimals={false} tickLine={false} axisLine={false} />
				<Tooltip formatter={(value) => formatCount(Number(value))} />
				<Legend />
				{headcount > 0 && (
					<ReferenceLine
						y={headcount}
						stroke="var(--chart-3)"
						strokeDasharray="4 4"
					/>
				)}
				<Bar
					dataKey="total"
					name="Presentes"
					fill="var(--chart-1)"
					radius={[4, 4, 0, 0]}
				/>
			</BarChart>
		</Chart>
	);
}
